export const getOBCustomerClientModel = (obCustomer) => {
    return {
        id: obCustomer.id,
        obId: obCustomer.ob_id,
        username: obCustomer.ob_username,
        createdDate: obCustomer.ob_created_date,
        obToken: obCustomer.ob_token,
    }
};

export const getOBCustomerSubmissionModel = (obCustomer, token) => {
    return {
        obId: obCustomer.id,
        obUsername: obCustomer.username,
        obCreatedDate: obCustomer.createdDate,
        obToken: token,
    }
};
